import React from 'react';
import { useParams } from 'react-router-dom';

import TaskRegistrationEditForm from './TaskRegistrationEditForm';
import { TaskRegistration } from '../../../Data/Classes';
import { REGISTERED } from '../../../Data/Constants';

function TaskRegistrationCreatePage(props) {
    const { taskId, eventId } = useParams();
    const taskReg = new TaskRegistration(0, "", 0, REGISTERED, "", false, taskId, "");

    return (
        <>
            <h1>Feladat-jelentkezés létrehozása</h1>
            <TaskRegistrationEditForm taskReg={taskReg} eventId={eventId} />
        </>
    );
}

export default TaskRegistrationCreatePage;
